module.exports = __webpack_public_path__ + "assets/5ec48820e3ec3b39acd565468d2402a5.svg";